export class GraphStorage {
    constructor(entities, edges, options) {
        var _a;
        this._entitiesById = new Map();
        this._entitiesByCategory = new Map();
        this._legalAdjacencyBySource = new Map();
        this.buildEntities(entities);
        this.buildEdges(edges, (_a = options === null || options === void 0 ? void 0 : options.bidirectional) !== null && _a !== void 0 ? _a : true);
    }
    buildEntities(entities) {
        var _a;
        this._entitiesById.clear();
        this._entitiesByCategory.clear();
        const uniqueEntities = [];
        for (const entity of entities) {
            if (this._entitiesById.has(entity.id)) {
                console.warn(`Duplicate entity id '${entity.id}' detected in input. Overriding previous value.`);
            }
            else {
                uniqueEntities.push(entity);
            }
            this._entitiesById.set(entity.id, entity); // Always keep the latest version
        }
        for (const entity of uniqueEntities) {
            const list = (_a = this._entitiesByCategory.get(entity.category)) !== null && _a !== void 0 ? _a : [];
            if (list.length === 0 && !this._entitiesByCategory.has(entity.category)) {
                this._entitiesByCategory.set(entity.category, list);
            }
            list.push(entity);
        }
    }
    addLegalEdgeBySource(source, target) {
        var _a;
        const legalAdjacencySet = (_a = this._legalAdjacencyBySource.get(source)) !== null && _a !== void 0 ? _a : new Set();
        legalAdjacencySet.add(target);
        this._legalAdjacencyBySource.set(source, legalAdjacencySet);
    }
    buildEdges(edges, bidirectional) {
        for (const { source, target } of edges) {
            this.addLegalEdgeBySource(source, target);
            if (bidirectional)
                this.addLegalEdgeBySource(target, source);
        }
    }
    getEntityById(id) {
        return this._entitiesById.get(id);
    }
    getEntitiesByCategory(category) {
        var _a;
        return (_a = this._entitiesByCategory.get(category)) !== null && _a !== void 0 ? _a : [];
    }
    getLegalEdges(sourceId) {
        var _a;
        return Array.from((_a = this._legalAdjacencyBySource.get(sourceId)) !== null && _a !== void 0 ? _a : []);
    }
    getLegalEdgesGroupedByCategory(sourceId) {
        var _a, _b;
        const targetIds = (_a = this._legalAdjacencyBySource.get(sourceId)) !== null && _a !== void 0 ? _a : new Set();
        const categoryToIdsMap = new Map();
        for (const targetId of targetIds) {
            const entity = this.getEntityById(targetId);
            if (entity === null || entity === void 0 ? void 0 : entity.category) {
                const category = entity.category;
                const currentIdList = (_b = categoryToIdsMap.get(category)) !== null && _b !== void 0 ? _b : [];
                currentIdList.push(targetId);
                if (!categoryToIdsMap.has(category)) {
                    categoryToIdsMap.set(category, currentIdList);
                }
            }
            else {
                console.warn(`Legal edge target ID '${targetId}' for source '${sourceId}' has no entity or category.`);
            }
        }
        return categoryToIdsMap;
    }
    getAllEntities() {
        return Array.from(this._entitiesById.values());
    }
    getEntitiesByCategoryMap() {
        return this._entitiesByCategory;
    }
    getAllCategories() {
        return Array.from(this._entitiesByCategory.keys());
    }
}
